<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <div>{{ 'Commons.Warning' | translate }}</div>
  <button type="button" mat-icon-button (click)="close()" tabindex="-1">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p style="white-space: pre-line">{{ message | translate }}</p>
</mat-dialog-content>
